import tippy from 'tippy.js';
import {scrollTo,getOffset,offsetTop} from "@/util/scroll/scroll-to.js"
/**
 * 
 * @param {*} type 
 * @param {*} isResponse 
 * @param {*} _errorClass 
 * @param {*} _input 
 */
function responsive(type,isResponse,_errorClass,_input){
    if(type==='update'){
        isResponse&&_errorClass&&_input.classList.add(_errorClass)
    }else{
        _errorClass&&_input.classList.add(_errorClass)
    }
}

/**
 * 
 * @param {*} el 
 * @param {*} binding 
 * @param {*} vNode 
 * @param {*} type 
 */
function setVerify(el,binding,vNode,type){
    const {required, regular,value,errorClass,isResponse,name,requiredMsg,formKey} = binding.value;//获取参数
    let _input=el.tagName.toLocaleLowerCase()=='input'?el:el.querySelector("input,textarea");//获取input元素
    let _errorClass= errorClass || 'input-error';//form-item错误样式
    const _formItem = formKey?`${formKey}__form__verify`:'form__verify';//表单验证标识
    _input.classList.add(_formItem);//添加表单验证标识
    let _verify={
        name:name,
        errorClass:_errorClass,
        isVerify:true,//校验是否通过
        result:{}
    };
    // 判断是否是否必填
    if(required){
        if(!value){
            responsive(type,isResponse,_errorClass,_input);
            _verify.isVerify = false
            _verify.result.required={value:false,message:requiredMsg||''}
        }else{
            _errorClass&&_input.classList.remove(_errorClass); 
        }
    }

    if(_verify.isVerify&&regular){//是否存在验证规则
        if(Array.isArray(regular)){//多个验证
            regular.forEach((item,index)=>{
                let _keys= Object.keys(item);
                const _reg = new RegExp(_keys[0]);
                if(!_reg.test(value)){
                    responsive(type,isResponse,_errorClass,_input);
                    _verify.isVerify=false
                    _verify.result[item[_keys[0]]]={value:false,message:item['message']};
                }else{
                    _errorClass&&_input.classList.remove(_errorClass); 
                }
            })
        }else{//单个验证
            let _objKeys = Object.keys(regular);
            const _msgIndex = _objKeys.findIndex((key)=>key==='message');
            const _reg = new RegExp(regular[_msgIndex===1?_objKeys[0]:_objKeys[1]]);//获取验证规则
            if(!_reg.test(value)){
                if(!required&&!value){//不必填时放开正则
                    _errorClass&&_input.classList.remove(_errorClass);
                }else{
                    responsive(type,isResponse,_errorClass,_input);//响应式表单验证
                    _verify.isVerify=false;
                    _verify.result[_msgIndex===1?_objKeys[0]:_objKeys[1]]={value:false,message:regular['message']};
                }
            }else{
                _errorClass&&_input.classList.remove(_errorClass); //移出错误样式
            }
        }
    }
    if(_input.className.indexOf(_errorClass)===-1){
        _input._tippy&&_input._tippy.destroy();
    }
    _input.dataset.verify=JSON.stringify(_verify);//利用dataset指令间传递验证结果
}

function formError(ele,content,options={}){
    return  tippy(ele, {
        content: content,
        allowHTML: true,
        hideOnClick: true,
        trigger: "click",
        theme:'tomato',
        placement: 'top-start',
        ...options
      });
}
function getErrorMsgList(errorObj){
    return Object.keys(errorObj).reduce((msgs,item)=> {
        errorObj[item].message&&msgs.push(errorObj[item].message);
        return msgs;
    },[])
}
/**
 * 
 * @param {*} msgs 
 * @returns 
 */
function renderError(msgs){
    return msgs.reduce((errorTip,msg,index)=> { 
         errorTip+=`${index===0?'<ul><li>':'<li>'}${msg}${index===msgs.length-1?'</li></ul>':'</li>'}`; 
         return errorTip
        },``)
}
function bindEvent(el){
    const _isInput=(ele)=>{return ele.tagName.toLocaleLowerCase()=='input'||ele.tagName.toLocaleLowerCase()=='textarea'};
    el.addEventListener('click', function(e){
        let _ele = e.srcElement||e.target;
        if(_isInput(_ele)&&_ele.dataset.verify){
            const _data = JSON.parse(_ele.dataset.verify);
            const {result,isVerify,errorClass} = _data;
            if(_ele.className.indexOf(errorClass)>-1){
                const _msgs=getErrorMsgList(result);
                if(!isVerify&&_msgs.length>0){
                    !_ele._tippy&&formError(_ele,renderError(_msgs))
                }
            }
        }
    }, true);
    el.addEventListener('blur', function(e){
        const _ele = e.srcElement||e.target;
        if(_isInput(_ele)&&_ele.className.indexOf('input-error')==-1){
            _ele._tippy&&_ele._tippy.destroy();
        }
    }, false);
}
function autoClick(ele) {
    // IE
    if (document.all) {
        ele.click();
    }
    // 其它浏览器
    else {
        var e = document.createEvent("MouseEvents");
        e.initEvent("click", true, true);
        ele.dispatchEvent(e);
    }
}
/**
 * 自定义form表单验证指令
 *  @param binding.value
 */

/** 示例
 *  { 
 * formKey:'', 表单唯一标识 配合formVerify指令使用 多个form表单嵌套用于获取对应的表单校验结果 可选参数 
 * required:true, 必填校验 可选参数
 * errorClass:'input-error', 验证未通过样式 可选参数
 * isResponse:false, 响应验证 默认为false
 * name:'acuPoint', 属性标识 必填参数
 * value:items.acuPoint, 需要验证的值 必填参数
 * nowVerify, 是否初始化立即验证 可选参数 默认不立即验证
 * regular, 自定义校验规则 可选参数  { ['max']:正则表达式,message:'穴位不能大于18个字符'} || [['max']:正则表达式,message:'穴位不能大于18个字符'}]
 * }
 */
const verify={
    bind: function (el, binding, vNode) {
        const {nowVerify} = binding.value;
        nowVerify&&setVerify(el,binding,vNode,'bind');

    },
    update: function (el, binding, vNode,oldVnode) {
        vNode!==oldVnode&&setVerify(el,binding,vNode,'update');
    }
}
/**
 * @param { 
 * form:String, 校验的form表单容器 接收一个id
 * formKey
 * isFirstVerify, 是否导航到第一个错误 ，默认false
 * event:event click事件
 * scrollBox //错误定位指定滚动容器
 * }
 * @returns{
 * isVerify:true, 是否验证通过
 * formValue:{} 表单验证结果 
 * }
 */
const formVerify={
     // 当被绑定的元素插入到 DOM 中时……
     inserted: function (el, binding, vNode) {
         const { form ,formKey,isFirstVerify, event,scrollBox}  = binding.value;//返回验证参数
         const  container = form?document.getElementById(form):document;//获取表单容器
         const _formItem = formKey?`${formKey}__form__verify`:'form__verify';
         bindEvent(container);
         el.addEventListener('click', function (e) {
          let elements = container.getElementsByClassName(_formItem);
          let _first;//第一个验证失败元素
          const _result = {
            isVerify:true,
            formValue:{}
          };
          for (let element of elements) {
           const _data = JSON.parse(element.dataset.verify);
           if(!_data.isVerify){
            !_first&&element.offsetParent&&(_first=element);//获取第一个验证失败元素
            _result.isVerify=false;
            _data.errorClass&&element.classList.add(_data.errorClass)
           }
           _result.formValue[_data.name]={isVerify:_data.isVerify,result:_data.result}
          }
          event(_result);
          if(isFirstVerify){
              //滚动至表单第一个错误处并获取焦点
              if(_first){
                let top= _first.getBoundingClientRect().top;
                console.log(top,{_first});
                if(scrollBox){
                    top = getOffset(_first).top;
                }
                
                scrollTo({to:top,scrollBox:scrollBox})
                //_first.scrollIntoView();
                _first.focus();
              }
          }
        })
      }
}
export {verify ,formVerify };


// WEBPACK FOOTER //
// ./src/directives/src/verify/formVerify.js